import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BoxCertificate } from "../../../model/box-certificate";

@Component({
  selector: 'aw-create-box-certificate',
  templateUrl: './create-box-certificate-dialog.component.html',
  styleUrls: ['./create-box-certificate-dialog.component.scss']
})
export class CreateBoxCertificateDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BoxCertificate,
    public dialogRef: MatDialogRef<CreateBoxCertificateDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


